<template>
  <div class="bx-content bx-message bx-typo--message">
    <svg class="icon icon-check">
      <use href="/images/icon_sprite.svg#check" />
    </svg>
    <span>Die Anmeldung war erfolgreich!</span>
  </div>
</template>
